import { Button, mergeClasses } from '@fluentui/react-components';
import { ChevronLeftRegular } from '@fluentui/react-icons';
import { FormattedMessage } from 'react-intl';

import { TeamsIcon } from '@tdp/common/teamsIcons';
import { createToolbar } from '@tdp/common/toolbar';
import { RootState, useSelector } from '@tdp/core';
import { FilterButton } from '@tdp/modules/apps';

import { useStyles } from './AppDetailsToolbar.styles';

const {
  Provider: AppDetailsToolbarProvider,
  Tools: AppDetailsTools,
  Toolbar,
} = createToolbar();

export interface IAppDetailsToolbarProps {
  className?: string;
  onPreview?: () => void;
  onPublish?: () => void;
  onNavigateBack?: () => void;
}

// This probably needs a portal so pages can render their own toolbar items.
// Also the visibility of the "save/revert" buttons is... funky.
// TODO(nibeauli): This should probably be a fluent component with slots rather than its current form
export function AppDetailsToolbar({
  className,
  onNavigateBack,
  onPreview,
  onPublish,
}: IAppDetailsToolbarProps) {
  const styles = useStyles();
  const showFilter = useSelector(
    (state: RootState) => state.analyticsFilter
  ).isVisible;
  //TODO(nibeauli): this is a toolbar, it needs more appropriate a11y attributes or just use the fluent Toolbar component
  return (
    <div className={mergeClasses(styles.container, className)} role="toolbar">
      <Button
        icon={<ChevronLeftRegular />}
        appearance="transparent"
        onClick={onNavigateBack}
      >
        Apps
      </Button>
      <Toolbar />
      {/** Unsure if these should be wired up here, callbacks passed in via props or if the buttons themselves should be portaled in like the tools */}
      {showFilter && <FilterButton />}
      <Button
        icon={<TeamsIcon />}
        className={mergeClasses(
          styles.previewInTeamsButton,
          showFilter && styles.previewInTeamsButtonWithFilter
        )}
        onClick={onPreview}
      >
        {/* TODO: this needs a Teams icon */}
        <FormattedMessage defaultMessage="Preview in Teams" />
      </Button>
      <Button appearance="primary" onClick={onPublish}>
        <FormattedMessage defaultMessage="Distribute" />
      </Button>
    </div>
  );
}

export { AppDetailsToolbarProvider, AppDetailsTools };
